import axios from 'axios'
import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {useHistory} from 'react-router-dom'
import dayjs from 'dayjs'
import {RootState} from '../../../../../setup'
import {QueryData} from '../../../../reusable-components/tables/DynamicTableTypes'
import {toast} from 'react-toastify'
import TableTitle from '../../../../reusable-components/tables/TableTitle'
import TableWrapper from '../../../../reusable-components/tables/TableWrapper'
import TableSearchBar from '../../../../reusable-components/tables/TableSearchBar'
import DynamicTable from '../../../../reusable-components/tables/DynamicTable'
import {Button} from '@mui/material'
import {PHYSICAL_ASSESSMENT_COLUMNS, PHYSICAL_ASSESSMENT_COLUMNS_DATA_MAPPING, PHYSICAL_ASSESSMENT_SORTING_COLUMNS} from '../../../Notes/Physical_Therapist_Notes/PHYSICAL_THERAPIST_TABLE_CONSTANT'

const selectAuth = (state: RootState) => state.auth
const selectTimeZone = (state: RootState) => state.timeZone.timeZone

export default function DeletedPhysicalAssessmentList() {
  const history = useHistory()
  const [filteredData, setFilteredData] = useState([])
  const [isFetchingData, setIsFetchingData] = useState(true)
  const timeZone = useSelector(selectTimeZone)
  const [searchTerm, setSearchTerm] = useState('')
  const [queryData, setQueryData] = useState<QueryData>({
    pageNumber: 1,
    pageSize: 5,
    currentPage: 1,
    totalCounts: 1,
    sortBy: '_id',
    sortDir: 'desc',
    searchTerm: '',
  })
  const auth = useSelector(selectAuth)
  const userPermissions = auth.user.roleId
  const [loadingStates, setLoadingStates] = useState({})

  useEffect(() => {
    const fetchData = async (page: number, pageSize: number, sortBy: string, sortDir: string, search: string) => {
      setIsFetchingData(true)
      try {
        const response = await axios.get(`/physicalAssessment/getAll?isDeleted=true`, {
          params: {
            page,
            pageSize,
            sortBy,
            sortOrder: sortDir,
            searchTerm: search,
          },
        })
        const {data, currentPage, totalCounts} = response.data
        const updatedData = data.map((item) => ({
          ...item,
          assessmentDate: item?.assessmentDate
            ? dayjs.utc(item.assessmentDate).tz(timeZone, true).format('MM-DD-YYYY')
            : 'No details provided',
        }))
        setFilteredData(updatedData)
        setQueryData((prevState) => ({
          ...prevState,
          currentPage,
          totalCounts,
        }))
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log('Request canceled', error.message)
        } else {
          console.log('Error: ', error.message)
          toast.error('Error fetching deleted physical assessments')
        }
      } finally {
        setIsFetchingData(false)
      }
    }

    fetchData(queryData.pageNumber, queryData.pageSize, queryData.sortBy, queryData.sortDir, queryData.searchTerm)
  }, [queryData.pageNumber, queryData.pageSize, queryData.sortBy, queryData.sortDir, queryData.searchTerm])

  const onUpdate = (row) => {
    history.push(`/deleted-notes/physical-therapist-notes/${row['_id']}`)
  }

  const onView = (row) => {
    if (row.clientId) {
      history.push(`/deleted-notes/physical-therapist-notes/notesEntries/${row.clientId}?assessmentId=${row._id}&noteType=${row.noteType}`)
    }
  }

  return (
    <div className='card'>
      <div className='card-body'>
        <TableTitle title='Deleted Physical Assessment'></TableTitle>
        <TableWrapper
          searchField={
            <TableSearchBar
              label='Search'
              variant='outlined'
              size='small'
              value={searchTerm}
              setQueryData={setQueryData}
              setSearchTerm={setSearchTerm}
              margin='normal'
              inputAdornmentPosition='start'
            />
          }
          tableButtons={
            <Button
              variant='contained'
              color='primary'
              onClick={() => history.goBack()}
            >
              Back
            </Button>
          }
          dynamicTable={
            <DynamicTable
              htmlColumns={[]}
              columns={PHYSICAL_ASSESSMENT_COLUMNS}
              data={filteredData}
              canUpdate={true}
              onUpdate={onUpdate}
              canView={true}
              onView={onView}
              loadingStates={loadingStates}
              sortingColumns={PHYSICAL_ASSESSMENT_SORTING_COLUMNS}
              setQueryData={setQueryData}
              queryData={queryData}
              columnDataMapping={PHYSICAL_ASSESSMENT_COLUMNS_DATA_MAPPING}
              tableLoader={isFetchingData}
              title='View deleted physical assessment'
            />
          }
        />
      </div>
    </div>
  )
}
